import { CardGrid } from '../../components/CardGrid';
import { EmptyMessage } from '../../components/EmptyMessage';
import { ItemCard } from '../../components/ItemCard';
import { Section, Title, TitleRow } from '../../components/Section';
import { SkeletonCard } from '../../components/SkeletonCard';
import type { SpaCategoryListTemplateProps } from './SpaCategoryListTemplate.types';

export function SpaCategoryListTemplate({
  categories,
  onSelectCategory,
  isLoading,
  titleLabel = 'Categories',
  fromPriceLabel = 'From',
  noResultsLabel = 'No categories available.',
  noImageLabel = 'No image',
}: SpaCategoryListTemplateProps) {
  if (isLoading && categories.length === 0) {
    return (
      <Section>
        <TitleRow>
          <Title>{titleLabel}</Title>
        </TitleRow>
        <CardGrid>
          {Array.from({ length: 6 }).map((_, index) => (
            <SkeletonCard key={index} variant="grid" />
          ))}
        </CardGrid>
      </Section>
    );
  }

  if (!isLoading && categories.length === 0) {
    return (
      <Section>
        <TitleRow>
          <Title>{titleLabel}</Title>
        </TitleRow>
        <EmptyMessage>{noResultsLabel}</EmptyMessage>
      </Section>
    );
  }

  return (
    <Section>
      <TitleRow>
        <Title>{titleLabel}</Title>
      </TitleRow>
      <CardGrid>
        {categories.map((category) => (
          <ItemCard
            key={category.id}
            variant="overlay"
            image={{ src: category.imageUrl, alt: category.name, placeholderLabel: noImageLabel }}
            title={category.name}
            price={
              category.price
                ? {
                    amount: category.price.amount,
                    currencyCode: category.price.currencyCode,
                    label: fromPriceLabel,
                  }
                : undefined
            }
            ariaLabel={category.name}
            onSelect={() => onSelectCategory(category.id)}
          />
        ))}
      </CardGrid>
    </Section>
  );
}
